import { config } from "../../config"
import { zip } from "../../helpers/utils"

export const wrds = {
  readAll: ({ from = null, limit = null, match = null, tag = null }) => {
    const base = config.apiUrl + `/wrds`,
      opt = {}

    const params = zip([from, limit, match, tag], ["f", "l", "q", "t"])

    let query = params
      .filter((param) => param[0] !== null && param[0] !== "")
      .map((param) => `&${param[1]}=${param[0]}`)
      .join("")

    if (query.length) query = "?" + query.substr(1)

    return { url: base + query, opt }
  },

  create: ({ token, words }) => {
    const url = config.apiUrl + `/wrds`,
      opt = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(words),
      }

    return { url, opt }
  },

  update: ({ token, word_id, word }) => {
    const url = config.apiUrl + `/wrds/${word_id}`,
      opt = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...word }),
      }

    return { url, opt }
  },

  delete: ({ token, word_id }) => {
    const url = config.apiUrl + `/wrds/${word_id}`,
      opt = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }

    return { url, opt }
  },

  batchDelete: ({ token, ids }) => {
    const url = config.apiUrl + `/wrds/batch-delete`,
      opt = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(ids),
      }

    return { url, opt }
  },
}
